// Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Pagination, EffectCoverflow } from "swiper/modules";
import { MapOfBrands, ProductData } from "~src/types/brandMapping";
import { useState } from "react";

type SliderData = ProductData[];

export default function ProductImageSlider({
  data,
  expandImage,
  brand,
}: {
  data: SliderData;
  expandImage: (data: ProductData, brand: MapOfBrands) => void;
  brand: MapOfBrands;
}) {
  const [visibleSlides, setVisibleSlides] = useState(5); // Initial number of slides to show
  const totalSlides = data.length;

  // Handle slide change to load more images
  const handleSlideChange = (swiper: any) => {
    const currentSlideIndex = swiper.activeIndex;

    // Load more images as the user scrolls
    if (currentSlideIndex + 3 > visibleSlides && visibleSlides < totalSlides) {
      setVisibleSlides((prev) => Math.min(prev + 3, totalSlides));
    }
  };

  return (
    <div style={{ maxWidth: "160px", minWidth: "160px" }}>
      <Swiper
        effect="coverflow"
        loop={true}
        centeredSlides={true}
        slidesPerView={3}
        pagination={false}
        navigation={false}
        onSlideChange={handleSlideChange}
        modules={[Pagination, EffectCoverflow]}
        className="mySwiper"
      >
        {data.slice(0, visibleSlides).map((item, index) => {
          if (!item.image_url) return null;

          return (
            <SwiperSlide key={index + item.image_url}>
              <img
                src={item.image_url}
                alt=""
                style={{ height: "auto" }}
                onClick={() => expandImage(item, brand)}
                onError={(e) => {
                  //@ts-ignore
                  e.target.src =
                    "/assets/illustrations/illustration_no_product_image.png";
                }}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
